/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FileNameInfoDto,
  ProblemDetails,
} from '../models/index';
import {
    FileNameInfoDtoFromJSON,
    FileNameInfoDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface GetCsvFileRequest {
    identifier: string;
}

export interface GetSelectedCsvFileRequest {
    masterDeviceId: string;
}

export interface GetSelectedCsvFileNameRequest {
    masterDeviceId: string;
}

export interface SelectCsvFileRequest {
    masterDeviceId: string;
    identifier: string;
}

/**
 * 
 */
export class UnicheckSimulatorApi extends runtime.BaseAPI {

    /**
     */
    async getCsvFileRaw(requestParameters: GetCsvFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.identifier === null || requestParameters.identifier === undefined) {
            throw new runtime.RequiredError('identifier','Required parameter requestParameters.identifier was null or undefined when calling getCsvFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/simulator/unicheck/csv/{identifier}`.replace(`{${"identifier"}}`, encodeURIComponent(String(requestParameters.identifier))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getCsvFile(requestParameters: GetCsvFileRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getCsvFileRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Blob>(response, errorHandlers);
    }

    /**
     */
    async getCsvFilesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/simulator/unicheck/csv`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getCsvFiles(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getCsvFilesRaw(initOverrides);
        return this.configuration.handleFunction<Array<string>>(response, errorHandlers);
    }

    /**
     */
    async getSelectedCsvFileRaw(requestParameters: GetSelectedCsvFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.masterDeviceId === null || requestParameters.masterDeviceId === undefined) {
            throw new runtime.RequiredError('masterDeviceId','Required parameter requestParameters.masterDeviceId was null or undefined when calling getSelectedCsvFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/simulator/unicheck/csv/selected/{masterDeviceId}`.replace(`{${"masterDeviceId"}}`, encodeURIComponent(String(requestParameters.masterDeviceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getSelectedCsvFile(requestParameters: GetSelectedCsvFileRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getSelectedCsvFileRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Blob>(response, errorHandlers);
    }

    /**
     */
    async getSelectedCsvFileNameRaw(requestParameters: GetSelectedCsvFileNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileNameInfoDto>> {
        if (requestParameters.masterDeviceId === null || requestParameters.masterDeviceId === undefined) {
            throw new runtime.RequiredError('masterDeviceId','Required parameter requestParameters.masterDeviceId was null or undefined when calling getSelectedCsvFileName.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/simulator/unicheck/csv/selected/{masterDeviceId}/name`.replace(`{${"masterDeviceId"}}`, encodeURIComponent(String(requestParameters.masterDeviceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => FileNameInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getSelectedCsvFileName(requestParameters: GetSelectedCsvFileNameRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getSelectedCsvFileNameRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<FileNameInfoDto>(response, errorHandlers);
    }

    /**
     */
    async selectCsvFileRaw(requestParameters: SelectCsvFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.masterDeviceId === null || requestParameters.masterDeviceId === undefined) {
            throw new runtime.RequiredError('masterDeviceId','Required parameter requestParameters.masterDeviceId was null or undefined when calling selectCsvFile.');
        }

        if (requestParameters.identifier === null || requestParameters.identifier === undefined) {
            throw new runtime.RequiredError('identifier','Required parameter requestParameters.identifier was null or undefined when calling selectCsvFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/simulator/unicheck/csv/selected/{masterDeviceId}/{identifier}`.replace(`{${"masterDeviceId"}}`, encodeURIComponent(String(requestParameters.masterDeviceId))).replace(`{${"identifier"}}`, encodeURIComponent(String(requestParameters.identifier))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async selectCsvFile(requestParameters: SelectCsvFileRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.selectCsvFileRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
